import {remove} from 'shared/utils/array-utils.fp';
import type {Criterion, ICriterionFactory} from './criteria.types';
import type {CriterionField} from './criteria.types';

export default class CriterionsFormManager {

    private criterions: Criterion[] = [];

    constructor(private criterionFactory: ICriterionFactory) {
    }

    public setCriterions(criterions: Criterion[]) {
        return this.criterions = criterions;
    }

    public getCriterions(): Criterion[] {
        return this.criterions;
    }

    public clearCriterions() {
        this.criterions = [];
    }

    public addCriterion(field) {
        this.criterions.push(this.createCriterionByField(field));
    }

    public removeCriterion(criterion: Criterion) {
        this.criterions = remove<Criterion>(criterion)(this.criterions);
    }

    public updateCriterionByField(criterion: Criterion, field) {
        this.criterions[this.criterions.indexOf(criterion)] = this.createCriterionByField(field);
    }

    public clearCriterionValues() {
        this.criterions.forEach((crit) => crit.clear());
    }

    public isAnyCriterionFilled(): boolean {
        return this.criterions.some((crit) => !crit.isEmpty());
    }

    public getNotEmptyCriterions(): Criterion[] {
        return this.criterions.filter((crit) => !crit.isEmpty());
    }

    public createCriterionByField(field: CriterionField): Criterion {
        switch (field.editor.type) {
            case 'search-text':
            case 'text-with-metadata':
                return this.criterionFactory.createTextCriterion(field);

            case 'number-range':
            case 'range':
                return this.criterionFactory.createBetweenCriterion(field);

            case 'acceptable':
            case 'single-acceptable':
            case 'multiple-acceptable':
            case 'acceptable-root':
            case 'multiple-acceptable-root':
                return this.criterionFactory.createInCriterion(field);

            case 'single-acceptable-root':
            case 'year':
                return this.criterionFactory.createEqCriterion(field);
        }

        throw new Error(`Unsupported editor ${field.editor.type}`);
    }
}
